import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './../../styles/admin/categorias.css';
import * as globals from '../../components/GlobalScripts.js';

const Admin_categorias = () => {
    const navigate = useNavigate();
    const path_api = localStorage.getItem('path_api');
    const [categoriasData, setCategoriasData] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 40;

    const [selectedCategoria, setSelectedCategoria] = useState({});
    const [showEditCategoriaModal, setShowEditCategoriaModal] = useState(false);

    useEffect(() => {
        get_categorias();
    }, []);

    const get_categorias = async (page = 1, searchT = '') => {
        globals.openViewCharge();
        try {
            const categoriasRes = await axios.post(`${path_api}/admin/categorias/get_categorias.php`, {
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                page,
                itemsPerPage,
                search: searchT,
            });

            if (categoriasRes.data.mensaje === 'success') {
                setCategoriasData(categoriasRes.data.categorias);
                setTotalPages(categoriasRes.data.totalPages);
                if (currentPage > categoriasRes.data.totalPages) {
                    setCurrentPage(categoriasRes.data.totalPages || 1);
                }
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: categoriasRes.data.mensaje || "No se obtuvieron las categorias",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }

        } catch (error) {
            globals.createAlert({
                type: "error",
                msg_title: "Error de red",
                msg: "No se pudo conectar con el servidor.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        } finally {
            globals.closeViewCharge();
        }
    };

    useEffect(() => {
        get_categorias(currentPage, search);
    }, [currentPage]);

    const handleSearchChange = e => setSearch(e.target.value);
    const handleSearchEnter = e => {
        if (e.key === 'Enter') {
            get_categorias(currentPage, search);
        }
    };

    const handlePrevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
    const handleFirstPage = () => setCurrentPage(1);
    const handleLastPage = () => setCurrentPage(totalPages);

    const handleEditCategoria = (id) => {
        const obj = categoriasData.find(c => String(c.id) === String(id));
        if (!obj) return;
        setSelectedCategoria(obj);
        setShowEditCategoriaModal(true);
    }

    const handleFieldChangeCategoria = e => {
        const { name, value } = e.target;
        setSelectedCategoria(prev => ({
            ...prev,
            data_categoria: {
                ...prev.data_categoria,
                [name]: value
            }
        }));
    };

    const handleSaveCategoria = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/admin/categorias/update_categorias.php`, {
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            categoria: selectedCategoria
        }).then(async response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La categoria se guardo con exito",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                await get_categorias(currentPage, search);
                setShowEditCategoriaModal(false);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "La categoria no se guardo",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error en el servidor al procesar la petición",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleAddOptForm = () => {
        if (!selectedCategoria.data_categoria?.newOptForm) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Ingresa una opción para el formulario",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
            return;
        }

        const optForm = selectedCategoria.data_categoria?.newOptForm;

        const nuevaLista = [...(selectedCategoria.data_categoria?.form || [])];

        const existe = nuevaLista.some(
            (item) => item.opt === optForm
        );

        if (existe) {
            globals.createAlert({
                type: "advertencia",
                msg_title: "Aviso",
                msg: `La opción "${optForm}" ya está en la lista.`,
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 3000,
            });
            return;
        }

        nuevaLista.push({
            opt: optForm
        });

        setSelectedCategoria((prev) => ({
            ...prev,
            data_categoria: {
                ...prev.data_categoria,
                form: nuevaLista,
                newOptForm: ''
            },
        }));
    };

    const handleRemoveList = (type, prodIndex) => {
        setSelectedCategoria((prev) => {
            const lista = [...prev.data_categoria[type]];
            lista.splice(prodIndex, 1);

            return {
                ...prev,
                data_categoria: {
                    ...prev.data_categoria,
                    [type]: lista,
                },
            };
        });
    };

    const handleOptionChange = (index, type, value) => {
        setSelectedCategoria(prev => ({
            ...prev,
            data_categoria: {
                ...prev.data_categoria,
                form: prev.data_categoria.form.map((item, i) =>
                    i === index
                        ? { ...item, [type]: value }
                        : item
                )
            }
        }));
    };

    return (
        <div className="page-categorias container-section flex-column gap-20" >
            <h3>Listado de categorías</h3>
            <div className="container-search flex-row justify-between align-center">
                <div className="search flex-row align-center gap-10">
                    <label>Busqueda (ID o nombre de la categoria):</label>
                    <input
                        type="text"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={handleSearchEnter}
                        className="input-primary"
                        placeholder="Presiona ENTER"
                    />
                </div>
                <div className="flex-row gap-10">
                    <button className="button-primary" onClick={() => { setSelectedCategoria({}); setShowEditCategoriaModal(true); }}>
                        Agregar
                    </button>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Categoria</th>
                            <th>Opciones de formulario</th>
                            <th>Ult. Actualización</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categoriasData?.map(row => (
                            <tr key={row.id}>
                                <td style={{ width: '60px' }}>{row.id}</td>
                                <td>{row.categoria}</td>
                                <td style={{ width: '160px' }}>{row.data_categoria?.form?.length ?? 0}</td>
                                <td style={{ width: '180px' }}>{row.updateAt}</td>
                                <td style={{ width: '60px' }} className="table-actions">
                                    <button className="edit-button" onClick={() => handleEditCategoria(`${row.id}`)}>
                                        <svg viewBox="0 0 24 24">
                                            <path d="M3 17.25V21h3.75l11-11-3.75-3.75-11 11zM20.71 7.04a1.003 1.003 0 0 0 0-1.41l-2.34-2.34a1.003 1.003 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="pagination">
                <button className="button-pagination" onClick={handleFirstPage} disabled={currentPage === 1}>
                    &lt;&lt;
                </button>
                <button className="button-pagination" onClick={handlePrevPage} disabled={currentPage === 1}>
                    Anterior
                </button>
                <p>Página {currentPage} de {totalPages}</p>
                <button className="button-pagination" onClick={handleNextPage} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
                <button className="button-pagination" onClick={handleLastPage} disabled={currentPage === totalPages}>
                    &gt;&gt;
                </button>
            </div>

            {showEditCategoriaModal && (
                <div className="modal-container">
                    <form className="modal" onSubmit={handleSaveCategoria}>
                        <div className='container-close-button'>
                            <button type='button' className="close-button" onClick={() => setShowEditCategoriaModal(false)}>
                                <svg viewBox="0 0 24 24">
                                    <path d="M18.3 5.71a1 1 0 00-1.42-1.42L12 9.17 7.12 4.29a1 1 0 00-1.42 1.42L10.59 12l-4.89 4.88a1 1 0 001.42 1.42L12 14.83l4.88 4.89a1 1 0 001.42-1.42L13.41 12l4.89-4.88z" />
                                </svg>
                            </button>
                        </div>
                        <h3>{!selectedCategoria?.id ? `Nueva categoria` : `Información de la categoria: ${selectedCategoria.categoria}`}</h3>

                        <div className='flex-column gap-10'>
                            <div className="form-group">
                                <label className='required'>Categoria</label>
                                <input
                                    type="text"
                                    name="categoria"
                                    className="input-primary"
                                    value={selectedCategoria.data_categoria?.categoria}
                                    onChange={handleFieldChangeCategoria}
                                    required
                                />
                            </div>

                            <div className="form-group margin-top-5">
                                <label className='required'>Descripción</label>
                                <textarea
                                    name="descripcion"
                                    className="input-primary"
                                    value={selectedCategoria?.data_categoria?.descripcion}
                                    onChange={handleFieldChangeCategoria}
                                    rows="4"
                                    required
                                />
                            </div>

                            <div className="form-group margin-top-50">
                                <label>Nueva opción del formulario</label>
                                <input
                                    type="text"
                                    name="newOptForm"
                                    className="input-primary"
                                    value={selectedCategoria.data_categoria?.newOptForm}
                                    onChange={handleFieldChangeCategoria}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            handleAddOptForm();
                                        }
                                    }}
                                />
                            </div>

                            <div className='flex-row justify-end'>
                                <button type='button' className='copy-placeholder green' onClick={handleAddOptForm}>
                                    Agregar opción
                                </button>
                            </div>

                            <div className="table-container margin-top-5">
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "calc(100% - 210px)" }}>Opción</th>
                                            <th style={{ width: '140px' }}>Costo</th>
                                            <th style={{ width: '70px' }}>Acción</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {(!selectedCategoria?.data_categoria?.form ||
                                            selectedCategoria.data_categoria.form.length === 0) ? (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "center" }}>
                                                    No hay opciones en la lista.
                                                </td>
                                            </tr>
                                        ) : (
                                            selectedCategoria.data_categoria.form.map((row, index) => (
                                                <tr key={index}>
                                                    <td style={{ paddingLeft: "var(--var-padding-20)" }}>
                                                        <input
                                                            type="text"
                                                            value={row.opt}
                                                            onChange={e => handleOptionChange(index, 'opt', e.target.value)}
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            step="1"
                                                            min="0"
                                                            value={row.precio}
                                                            onChange={e => handleOptionChange(index, 'precio', e.target.value)}
                                                            required
                                                        />
                                                    </td>
                                                    <td className="table-actions" style={{ width: '70px' }}>
                                                        <button
                                                            type='button'
                                                            className="delete-button"
                                                            onClick={() => handleRemoveList('form', index)}
                                                        >
                                                            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M13.1406 1.82675C13.141 1.82675 13.1413 1.82711 13.1421 1.82782L14.1722 2.85818C14.173 2.85872 14.1731 2.85907 14.1733 2.85961C14.1734 2.85996 14.1734 2.86033 14.1733 2.86068C14.1733 2.86122 14.173 2.86157 14.1722 2.86229L9.03474 7.99979L14.1722 13.1373C14.173 13.138 14.1731 13.1384 14.1733 13.1389C14.1734 13.1393 14.1734 13.1397 14.1733 13.1401C14.1733 13.1405 14.173 13.1409 14.1722 13.1416L13.1419 14.1718C13.1413 14.1725 13.141 14.1726 13.1406 14.1728C13.1402 14.1729 13.1398 14.1729 13.1394 14.1728C13.1388 14.1728 13.1385 14.1725 13.1378 14.1718L8.00028 9.03425L2.86278 14.1718C2.86206 14.1725 2.86171 14.1726 2.86117 14.1728C2.86076 14.1729 2.86033 14.1729 2.85992 14.1728C2.85956 14.1728 2.85921 14.1725 2.85849 14.1718L1.82831 13.1414C1.8276 13.1409 1.82742 13.1405 1.82724 13.1401C1.82712 13.1397 1.82712 13.1393 1.82724 13.1389C1.82724 13.1384 1.8276 13.138 1.82831 13.1373L6.96581 7.99979L1.82831 2.86229C1.8276 2.86157 1.82742 2.86122 1.82724 2.86068C1.82712 2.86027 1.82712 2.85984 1.82724 2.85943C1.82724 2.85907 1.8276 2.85872 1.82831 2.858L2.85867 1.82782C2.85921 1.82711 2.85956 1.82693 2.85992 1.82675C2.86033 1.82663 2.86076 1.82663 2.86117 1.82675C2.86171 1.82675 2.86206 1.82711 2.86278 1.82782L8.00028 6.96532L13.1378 1.82782C13.1385 1.82711 13.1388 1.82693 13.1394 1.82675C13.1398 1.82663 13.1402 1.82663 13.1406 1.82675Z" fill="#FF6760" />
                                                            </svg>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="modal-actions flex-row gap-10 justify-end">
                            <button
                                type="button"
                                className="button-primary cancel"
                                onClick={() => setShowEditCategoriaModal(false)}
                            >
                                Cancelar
                            </button>
                            <button type="submit" className="button-primary">
                                {!selectedCategoria?.id ? `Crear` : `Actualizar`}
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default Admin_categorias;
